import { CartMissingResponseException, Exception } from '@scalefast/core';
import { tap } from 'rxjs/operators';
const findErrorInMap = (error, exceptionMap) => {
  const findCriteria = item => item.errorCode == error.status;
  const item = exceptionMap.find(findCriteria);
  return item?.exception || new Exception(error.status, error.statusText);
};
const CartResponseProcessor = {
  handle: exceptionMap => {
    return tap(value => {
      if (!value) {
        throw new CartMissingResponseException();
      }
      if (value.name == 'HttpErrorResponse') {
        throw findErrorInMap(value, exceptionMap);
      }
    });
  }
};
export default CartResponseProcessor;
